import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { trackPageView } from '../config/firebase';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page views
    const pageTitle = document.title;
    trackPageView(location.pathname + location.search, pageTitle);
  }, [location]);

  return (
    <Helmet>
      {/* Google Analytics 4 (GA4) Global Site Tag */}
      <script async src="https://www.googletagmanager.com/gtag/js?id=G-BZ2KBHPLJJ"></script>
      <script>
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-BZ2KBHPLJJ', {
            page_title: document.title,
            page_location: window.location.href,
            send_page_view: true,
            custom_map: {
              'custom_parameter_1': 'project_type',
              'custom_parameter_2': 'cost_range'
            }
          });
          
          // Enhanced ecommerce for construction cost estimates
          gtag('config', 'G-BZ2KBHPLJJ', {
            custom_map: {
              'custom_parameter_1': 'project_type',
              'custom_parameter_2': 'location',
              'custom_parameter_3': 'cost_estimate'
            }
          });
          
          // Track construction cost tool usage
          window.trackConstructionEvent = function(action, projectType, location, value) {
            gtag('event', action, {
              event_category: 'Construction_Cost_Tool',
              event_label: projectType + '_' + location,
              value: value || 0,
              custom_parameter_1: projectType,
              custom_parameter_2: location
            });
          };
          
          // Track form submissions
          window.trackFormSubmission = function(formType, projectType) {
            gtag('event', 'form_submit', {
              event_category: 'Form_Interaction',
              event_label: formType,
              custom_parameter_1: projectType
            });
          };
          
          // Track estimate requests
          window.trackEstimateRequest = function(projectType, city, state, estimatedCost) {
            gtag('event', 'estimate_request', {
              event_category: 'Cost_Estimation',
              event_label: projectType,
              value: estimatedCost || 0,
              custom_parameter_1: projectType,
              custom_parameter_2: city + ', ' + state,
              custom_parameter_3: estimatedCost
            });
            
            // Also track with Clarity
            if (window.clarity) {
              window.clarity('event', 'estimate_request', {
                project_type: projectType,
                location: city + ', ' + state,
                estimated_cost: estimatedCost
              });
            }
          };
          
          // Track calculator usage with Clarity
          window.trackCalculatorUsage = function(step, projectType, data) {
            if (window.clarity) {
              window.clarity('event', 'calculator_step', {
                step: step,
                project_type: projectType,
                data: data
              });
            }
          };
          
          // Track blog page engagement with Clarity
          window.trackBlogEngagement = function(action, projectType, location) {
            if (window.clarity) {
              window.clarity('event', 'blog_engagement', {
                action: action,
                project_type: projectType,
                location: location
              });
            }
          };
        `}
      </script>
      
      {/* Additional tracking for SEO performance */}
      <script>
        {`
          // Track SEO landing page performance
          if (window.location.pathname.includes('/estimate/') || 
              window.location.pathname.includes('/cost/') || 
              window.location.pathname.includes('/calculator/')) {
            
            const pathParts = window.location.pathname.split('/');
            const projectType = pathParts[2] || 'unknown';
            const state = pathParts[3] || 'unknown';
            const city = pathParts[4] || null;
            
            gtag('event', 'seo_landing_page_view', {
              event_category: 'SEO_Performance',
              event_label: projectType + '_' + state + (city ? '_' + city : ''),
              custom_parameter_1: projectType,
              custom_parameter_2: state,
              custom_parameter_3: city
            });
          }
          
          // Track search engine referrals
          const referrer = document.referrer;
          if (referrer && (referrer.includes('google.') || referrer.includes('bing.') || referrer.includes('yahoo.'))) {
            gtag('event', 'search_engine_referral', {
              event_category: 'Traffic_Source',
              event_label: referrer,
              referrer: referrer
            });
          }
          
          // Track AI chatbot referrals (if any)
          if (referrer && (referrer.includes('chat.openai.') || referrer.includes('claude.') || referrer.includes('bard.'))) {
            gtag('event', 'ai_chatbot_referral', {
              event_category: 'AI_Traffic',
              event_label: referrer,
              referrer: referrer
            });
          }
        `}
      </script>

      {/* Facebook Pixel - Disabled until proper Pixel ID is configured
      <script>
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', 'YOUR_FACEBOOK_PIXEL_ID'); // Replace with actual pixel ID if needed
          fbq('track', 'PageView');
        `}
      </script>
      */}
      
      {/* Microsoft Clarity */}
      <script type="text/javascript">
        {`
          (function(c,l,a,r,i,t,y){
              c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
              t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
              y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "t8hkoy2o73");
        `}
      </script>
    </Helmet>
  );
};

export default Analytics;
